import styled from 'styled-components';
import { desktop_breakpoint } from 'pubweb-smokey/dist/components/GridSystem/_vars_widths.js';
import Colors from 'pubweb-smokey/dist/colors';

export const InspirationMediaViewStyles = styled.div`
  background-color: ${Colors.primary.white.standard};
  min-height: 25vh;
  max-width: 90vw;
  padding: 25px;
  width: 600px;

  .modal-component {
    left: -80%;
    height: 100vh;
    top: -5.5%;
    width: 200vw;
  }

  img {
    max-width: 100%;
    height: 100%;
  }

  p,
  h3,
  a,
  a:link,
  a:hover,
  a:visited {
    text-decoration: none;
  }

  a {
    align-items: center;
    display: flex;
  }

  h3 {
    display: inline-block;
    margin-bottom: 10px;
  }

  .chevron {
    display: inline-block;

    svg {
      margin-left: 20px;
      height: 20px;
      width: 20px;
    }
  }

  .media-loading {
    align-items: center;
    display: flex;
    justify-content: center;
    height: 50vw;
    margin: auto;
    max-width: 500px;
    width: 100%;
  }

  .media-image {
    height: 100vw;
    margin: auto;
    max-height: 500px;
    max-width: 500px;
    position: relative;
    width: 100%;

    .sk-fading-circle {
      left: 50%;
      position: absolute;
      top: 50%;
      transform: translate(-50%, -50%);
    }
  }

  .media-details {
    display: flex;
    flex-direction: column;
    margin: auto;
    margin-top: 10px;
    max-width: 450px;

    .share,
    .favorite {
      align-items: center;
      background-color: ${Colors.primary.white.standard};
      cursor: pointer;
      display: flex;
      justify-content: space-around;
      height: 28px;
      width: 28px;
    }

    .share {
      box-shadow: 0 0 4px 2px rgba(80, 80, 80, 0.05);
      border: 1px solid ${Colors.secondary.grey6.standard};
      border-radius: 25px;
      margin-right: 10px;
      padding-top: 4px;
    }
  }

  .media-actions {
    display: flex;
    flex-direction: row;
    margin-bottom: 10px;
  }

  .media-header {
    a {
      display: inline-flex;
    }
  }

  iframe {
    display: block;
    max-height: 475px;
    height: 50vw;
    margin: auto;
    max-width: 450px;
    width: 100%;
    min-height: 300px;
  }

  .favoriting-heart-circle {
    overflow: hidden;
  }

  @media only screen and (min-width: ${desktop_breakpoint}px) {
    padding: 20px;

    .media-details {
      border-top: 1px solid ${Colors.primary.black.standard};
      flex-flow: row-reverse;
      justify-content: space-between;
      margin-top: 20px;
      max-width: 800px;
      padding: 10px;
    }
    .media-loading {
      max-height: 450px;
    }

    iframe {
      max-width: 750px;
    }
  }
`;
